import { RouteStep } from '~/routes/calculations/types';

const step: RouteStep = {
  route: '/homeowners-insurance/quotes/confirmation-call-scheduled',
  isAccessible: () => true,
  breadcrumbStep: 'done',
};

export default step;
